import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { decisionLabel } from "./decision-record-presentation";

export function ActionGridRow({
  children,
  className,
  header = false,
}: {
  children: React.ReactNode;
  className?: string;
  header?: boolean;
}): React.ReactElement {
  return (
    <div
      className={cn(
        "grid grid-cols-[minmax(190px,245px)_145px_minmax(280px,1fr)_130px_160px] items-center gap-[14px] border-b border-line px-4",
        header
          ? "min-h-[33px] bg-canvas text-[11px] font-semibold uppercase leading-[14px] text-muted-foreground"
          : "min-h-[66px] py-3.5",
        className,
      )}
    >
      {children}
    </div>
  );
}

export function ActionColumn({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  return <div className={cn("min-w-0", className)}>{children}</div>;
}

export function Fact({
  label,
  mono = false,
  value,
}: {
  label: string;
  mono?: boolean;
  value: string;
}): React.ReactElement {
  return (
    <div className="flex min-w-0 items-start justify-between gap-4 text-xs leading-4">
      <dt className="shrink-0 text-muted-foreground">{label}</dt>
      <dd className={cn("min-w-0 truncate text-right text-ink", mono && "font-mono tabular-nums")}>
        {value}
      </dd>
    </div>
  );
}

export function DecisionBadge({ status }: { status: string }): React.ReactElement {
  const { t } = useTranslation("aiOperations");
  const normalized = status === "modify_approve" ? "approved" : status;
  const variant =
    normalized === "approved" || normalized === "executed" || normalized === "succeeded"
      ? "success"
      : normalized === "failed" || normalized === "rollback_failed"
        ? "destructive"
        : normalized === "pending" ||
            normalized === "processing" ||
            normalized === "expired" ||
            normalized === "rolling_back"
          ? "warning"
          : "neutral";
  return (
    <Badge variant={variant} className="h-7 px-[9px] text-xs font-semibold capitalize">
      {decisionLabel(status, t)}
    </Badge>
  );
}
